import { render } from "./KimbapView.vue?vue&type=template&id=20145959"
import script from "./KimbapView.vue?vue&type=script&lang=js"
export * from "./KimbapView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__